var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from "react";
import ClientSchemeSelectionSB from "./clinetSchemeSelectionFlow/ClientSchemeSelectionSB";
import TocHoc from "@frameworks/web/components/features/TOC/TocHoc";
import MutualFund from "@frameworks/shared-library/components/TransactionJourney/MutualFund/MutualFund";
export var RedeemSidebarFlow = function (_a) {
    var openSidebar = _a.openSidebar, setOpenSidebar = _a.setOpenSidebar, selectedSchemeData = _a.selectedSchemeData, transactionType = _a.transactionType;
    var _b = __read(useState(false), 2), mfToc = _b[0], setMfToc = _b[1];
    var _c = __read(useState(null), 2), schemeDataForToc = _c[0], setSchemedataForToc = _c[1];
    var _d = __read(useState(null), 2), clientDetailsToSidebar = _d[0], setClientDetailsToSidebar = _d[1];
    useEffect(function () {
        if (openSidebar) {
            setClientDetailsToSidebar(null);
        }
    }, [openSidebar]);
    return (React.createElement("div", null,
        openSidebar && (React.createElement(ClientSchemeSelectionSB, { setVisible: setOpenSidebar, schemeDetails: selectedSchemeData, onClickCancel: function () {
                setOpenSidebar(false);
            }, onClickContinue: function () {
                setMfToc(true);
                setOpenSidebar(false);
            }, ClientDetailsToSidebar: clientDetailsToSidebar, setClientDetailsToSidebar: setClientDetailsToSidebar, schemeDataForToc: schemeDataForToc, setSchemeDataForToc: setSchemedataForToc, transactionType: transactionType })),
        mfToc && schemeDataForToc && (React.createElement(TocHoc, { component: MutualFund, clientDetails: clientDetailsToSidebar, isin: schemeDataForToc.isin, schemeCode: schemeDataForToc.grpCode, schemeGroupCode: selectedSchemeData === null || selectedSchemeData === void 0 ? void 0 : selectedSchemeData.schemeGrp, schemeplan: schemeDataForToc === null || schemeDataForToc === void 0 ? void 0 : schemeDataForToc.schemePlan, onlyEQACC: true, investmentType: transactionType, dontCloseOnOutsideClick: true, setShowTOC: function () {
                setMfToc(false);
            }, outsideClick: function () {
                setMfToc(false);
            }, showToc: mfToc, blurBackground: true, sourcePage: "PRODUCT-PAGE" }))));
};
export default RedeemSidebarFlow;
